import { observable, action, runInAction } from 'mobx';
import { RootStore } from './RootStore';
import request from '../utils/request';

// 存储区
export default class SZParkStore {
    rootStore: RootStore
    @observable ts = new Date();
    @observable infoMap: any = {}; //1:公园列表，2:医院列表，3:文体列表，4:站点列表
    @observable selectedList: any = [];
    @observable selectedMap: any = {};

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore
        this.infoMap[1] = [];
        this.infoMap[2] = [];
        this.infoMap[3] = [];
        this.infoMap[4] = [];
        const tempMap = JSON.parse(localStorage.getItem('selectedMap') || '{"1":[],"2":[],"3":[],"4":[]}');
        this.selectedMap[1] = tempMap[1] || [];
        this.selectedMap[2] = tempMap[2] || [];
        this.selectedMap[3] = tempMap[3] || [];
        this.selectedMap[4] = tempMap[4] || [];
    }

    @action
    refreshSelectedList() {
        let selectedList: any = [];
        for (let type = 1; type <= 4; type++) {
            for (const selectedItem of this.selectedMap[type]) {
                for (const item of this.infoMap[type]) {
                    if (item.name == selectedItem){
                        selectedList.push(item)
                    }
                }
            }
        }
        this.selectedList = selectedList;
    }

    @action
    refreshTs() {
        this.ts = new Date();
    }

    @action
    async getList(type: number) {
        const response = await getParkList(type);
        if (response == undefined)
            return;
        runInAction(() => {
            if (response.status == 200) {
                this.infoMap[type] = response.json.message;
                this.refreshSelectedList();
            }
        })
    }
}

//请求区
export async function getParkList(type: number) {
    return request('/api/szpark/getList?type=' + type, {
        method: 'GET',
    })
}

